import TagManager from 'react-gtm-module';

// TYPES
import { AppThunk } from 'redux/type';

const initializeGTM = (): AppThunk => async () => {
  const tagManagerArgs = {
    gtmId: process.env.REACT_APP_GOOGLE_TAG_ID || ''
  };

  // Set cookie_flags globally before GTM fires any tags so all GA cookies
  // (set by GTM-loaded GA4/gtag) inherit Secure and SameSite=None.
  (window as any).dataLayer = (window as any).dataLayer || [];
  (window as any).gtag = (window as any).gtag || function (...args: unknown[]) {
    (window as any).dataLayer.push(args);
  };
  (window as any).gtag('set', { cookie_flags: 'SameSite=None;Secure' });

  TagManager.initialize(tagManagerArgs);

  console.log('Google GTM initialized successfully');
};

export { initializeGTM };
